'use client';

import { DevEnrollmentSwitch } from '@/components/dev/enrollment-switch';
import { PublicFooter } from '@/components/nav/public-footer';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useEnrollmentStatus } from '@/lib/enrollment-config';
import Image from 'next/image';
import Link from 'next/link';

export default function HomePage() {
  const status = useEnrollmentStatus();

  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex flex-1 flex-col items-center justify-center p-4">
        <Image
          src="/images/Embrace_for_Good_Black_Logo.png"
          alt="Lincoln Embrace for Good"
          width={400}
          height={120}
          priority
        />

        {/* Heading - only for enrollment_open and waitlist_open */}
        {(status === 'enrollment_open' || status === 'waitlist_open') && (
          <h1 className="mt-8 text-2xl font-semibold">Welcome to Embrace for Good!</h1>
        )}

        {/* Content based on enrollment status */}
        {status === 'pre_enrollment' && (
          <p className="mt-8 max-w-md text-center text-lg text-muted-foreground">
            Enrollment will open February 17 at 12PM EST. Please check back then, and reach out to
            Program HQ with any questions!
          </p>
        )}

        {(status === 'enrollment_open' || status === 'waitlist_open') && (
          <div className="mt-4 max-w-2xl space-y-4 text-center text-muted-foreground">
            <p>
              Lincoln Brand Exclusive Advertising Program (LBEAP) eligible retailers are invited to
              participate in the 2026 Embrace for Good program. Events are limited and will be
              allocated on a first-come, first-served basis. Eligible retailers may host their
              test-drive event anytime between April 15, 2026 – November 30, 2026 (date to be chosen
              by the Retailer and approved by Lincoln).
            </p>
            <p>
              Retailers are not required to have a specific event or benefiting charity selected at
              the time of enrollment, as a dedicated Program Headquarters (PHQ) will be available to
              provide end-to-end support, including assisting with event selection. Once your
              enrollment has been submitted, you will be able to schedule an onboarding call with
              PHQ to work on planning and event selection.
            </p>
            <p>
              All events will be vetted to ensure that both the organization and how the funds will
              be used align with the guidelines provided herein.
            </p>
            <p>Join us and experience the joy of giving back!</p>
          </div>
        )}

        {status === 'enrollment_closed' && (
          <p className="mt-8 max-w-md text-center text-lg text-muted-foreground">
            Thank you for your interest in Lincoln&apos;s Embrace for Good program! The 2026 program
            has ended. Check back soon or contact PHQ for updates on next year&apos;s program.
          </p>
        )}

        {/* Waitlist notice */}
        {status === 'waitlist_open' && (
          <Alert className="mt-6 max-w-md">
            <AlertDescription className="font-bold text-destructive">
              NOTE: Although this year&apos;s program is currently at capacity, spots do often
              become available. We encourage you to complete the enrollment form to be added to the
              waitlist, and our team will reach out if we are able to accommodate your event.  
            </AlertDescription>
          </Alert>
        )}

        {/* CTA Buttons */}
        {(status === 'enrollment_open' || status === 'waitlist_open') && (
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:gap-4">
            <Button asChild>
              <Link href="/signup">Sign Up</Link>
            </Button>
            <Button variant="outline" asChild>
              <Link href="/login">Log In</Link>
            </Button>
            <Button variant="ghost" asChild>
              <Link href="/password">Forgot Password?</Link>
            </Button>
          </div>
        )}

        {status === 'enrollment_closed' && (
          <div className="mt-8">
            <Button variant="outline" asChild>
              <Link href="/login">Log In</Link>
            </Button>
          </div>
        )}
      </div>

      <PublicFooter />
      <DevEnrollmentSwitch />
    </div>
  );
}
